import type { QuestGroupState, QuestState } from "@ui-kit/QuestList";
import {
  HIDE_QUEST,
  RESET_QUEST,
  UNLOCK_QUEST,
  UPDATE_QUEST,
  UPDATE_QUEST_GROUP,
} from "./actions";

export const initialState: QuestGroupState[] = [];

export type QuestActionType =
  | {
      type: typeof UPDATE_QUEST;
      payload: { id: string; quest: Partial<QuestState> };
    }
  | { type: typeof UNLOCK_QUEST; payload: { id: string } }
  | { type: typeof HIDE_QUEST; payload: { id: string } }
  | {
      type: typeof UPDATE_QUEST_GROUP;
      payload: { id: string; questGroups: QuestGroupState[] };
    }
  | { type: typeof RESET_QUEST };

export const questReducer = (
  state: QuestGroupState[],
  action: QuestActionType,
): QuestGroupState[] => {
  switch (action.type) {
    case UPDATE_QUEST_GROUP: {
      return action.payload.questGroups;
    }

    case UPDATE_QUEST: {
      const { id, quest } = action.payload;
      return state.map((group: QuestGroupState) => ({
        ...group,
        quests: group.quests.map((storedQuest: QuestState) => {
          if (storedQuest.ruleId === id) {
            return { ...storedQuest, ...quest } as QuestState;
          }
          return storedQuest;
        }),
      })) as QuestGroupState[];
    }

    case UNLOCK_QUEST: {
      const { id } = action.payload;
      return state.map((group: QuestGroupState) => ({
        ...group,
        quests: group.quests.map((storedQuest: QuestState) =>
          storedQuest.ruleId === id
            ? {
                ...storedQuest,
                locked: false,
                lockedUntil: undefined,
              }
            : storedQuest,
        ),
      }));
    }

    case HIDE_QUEST: {
      const { id } = action.payload;
      return state.map((group: QuestGroupState) => ({
        ...group,
        quests: group.quests.map((storedQuest: QuestState) =>
          storedQuest.ruleId === id
            ? { ...storedQuest, hidden: true }
            : storedQuest,
        ),
      }));
    }

    case RESET_QUEST:
      return state.map((group: QuestGroupState) => ({
        ...group,
        quests: group.quests.map((storedQuest: QuestState) => {
          if (storedQuest.status === "in-progress") {
            return { ...storedQuest, status: "pending" };
          }
          return storedQuest;
        }),
      }));

    default:
      return state;
  }
};
